import { useViewport } from '@xyflow/react';
import { Icon } from './Icon';

interface Props {
  onSnap: () => void;
  onZoomFar: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export function ZoomWidget({ onSnap, onZoomFar, onZoomIn, onZoomOut }: Props) {
  const { zoom } = useViewport();
  const pct = Math.round(zoom * 100);

  return (
    <div className="zoom-widget" role="toolbar" aria-label="Zoom controls">
      <button
        type="button"
        className="zw-btn"
        onClick={onZoomFar}
        title="Bird's-eye view · Shift+Z"
        aria-label="Zoom out to bird's-eye view"
      >
        <Icon name="minus" size={14} variant="silver" />
      </button>

      <button
        type="button"
        className="zw-btn zw-snap"
        onClick={onSnap}
        title="Snap to fit · F"
      >
        <Icon name="grid" size={14} variant="gold" />
        <span className="zw-pct">{pct}%</span>
      </button>

      <button
        type="button"
        className="zw-btn"
        onClick={onZoomIn}
        title="Zoom in"
        aria-label="Zoom in"
      >
        <Icon name="plus" size={14} variant="silver" />
      </button>
    </div>
  );
}
